/**
 * Account panel state management
 */
export default {
    namespaced: true,
    
    state: {
        showMap: (localStorage['showMap']) ? true : false,
        markers: {},
        infoWindows: {},
    },

    getters: {
        allInfoWindows(state) {
            return state.infoWindows;
        },
        
        allMarkers(state) {
            return state.markers;
        },
        
        infoWindowById: (state) => (id) => {
          if ( state.infoWindows[id] ) {
            return state.infoWindows[id];
          }
        },
        
        markerById: (state) => (id) => {
          if ( state.markers[id] ) {
            return state.markers[id];
          }
        },
        
        showMap(state) {
            return state.showMap;
        },
    },
    
    mutations: {
        purgeInfoWindows(state) {
            state.infoWindows = {};
        },
        
        purgeMarkers(state) {
            state.markers = {};
        },
        
        storeInfoWindow(state, payload) {
            state.infoWindows[payload.id] = payload.infoWindow;
        },
        
        storeMarker(state, payload) {
            state.markers[payload.id] = payload.marker;
        },
        
        toggleMap(state) {
            state.showMap = !state.showMap;
            
            if ( state.showMap ) {
                localStorage['showMap'] = 1;
            } else {
                delete localStorage['showMap'];
            }
        }
    },
    
    actions: {
        //action(context) {
        //},
    }
}
